import { SagaIterator } from "redux-saga";
import { call, put, takeLatest } from "redux-saga/effects";
import { IResponse } from "../../../../libs/requester/IResponse";
import { requester } from "../../../../libs/requester/requester-axios";
import { setCategories, setLoading } from "../../repository/slice";

function* getCategoriesWithoutTreeWorker({ payload }: any): SagaIterator {
    try {
        yield put(setLoading(true));
        const { data, message, isError }: IResponse<any> = yield call(requester.get, "/api/admin/category", payload);
        if (isError) {

        } else {
            yield put(setCategories({ categories: data.rows, count: data.count }));
        }
    } catch (error) {
        console.error("getCategoriesWithoutTreeWorker: ", error);
    } finally {
        yield put(setLoading(false));
    };
};

export function* getCategoriesWithoutTreeWatcher() {
    yield takeLatest("@saga/GET_CATEGORIES_WITHOUT_TREE", getCategoriesWithoutTreeWorker);
};
